import { render, staticRenderFns } from "./ViewBudget.vue?vue&type=template&id=0ee2ba88"
import script from "./ViewBudget.vue?vue&type=script&lang=js"
export * from "./ViewBudget.vue?vue&type=script&lang=js"
import style0 from "./ViewBudget.vue?vue&type=style&index=0&id=0ee2ba88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports